import { useState, useEffect } from 'react';

const useScroll = element => {
  const [lastScrollTop, setLastScrollTop] = useState(0);
  const [bodyOffset, setBodyOffset] = useState(
    typeof window === 'undefined' || !window.document ? 0 : (element || document.body).getBoundingClientRect()
  );
  const [scrollY, setScrollY] = useState(bodyOffset.top);
  const [scrollBottom, setScrollBottom] = useState(bodyOffset.bottom);
  const [scrollX, setScrollX] = useState(bodyOffset.left);
  const [scrollDirection, setScrollDirection] = useState();

  const listener = () => {
    setBodyOffset(
      typeof window === 'undefined' || !window.document ? 0 : (element || document.body).getBoundingClientRect()
    );
    setScrollY(-bodyOffset.top);
    setScrollBottom(bodyOffset.bottom);
    setScrollX(bodyOffset.left);
    setScrollDirection(lastScrollTop > -bodyOffset.top ? 'down' : 'up');
    setLastScrollTop(-bodyOffset.top);
  };

  useEffect(() => {
    window.addEventListener('scroll', listener);
    return () => {
      window.removeEventListener('scroll', listener);
    };
  });

  return {
    scrollY,
    scrollBottom,
    scrollX,
    scrollDirection,
  };
};

export default useScroll;